export default __webpack_public_path__ + "static/media/ic_avalanche_16.90aca01d.svg";